import { Dispatch } from 'react';
import axios, { AxiosResponse } from 'axios';
import ReviewsEndpointConfig from '../../server/configs/ReviewsEndpointConfig';
import { ThunkResult } from './store';
import { loadReviews, loadReviewsSuccess, loadReviewsError, LoadReviewsActionPayload } from './actions';

function loadReviewsRequest(
  dispatch: Dispatch<any>,
  { product_id, store_id, page, limit }: LoadReviewsActionPayload
) {
  const loadReviewsPromise = new Promise<AxiosResponse>((resolve, reject) => {
    const { host, servicePath } = { ...ReviewsEndpointConfig };
    const API_URL = `${host.replace(/\/$/, '')}${servicePath ? `/${servicePath}` : ''}`;
    axios
      .get(API_URL, {
        params: {
          product_id,
          store_id,
          page,
          limit
        }
      })
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject();
        dispatch(loadReviewsError(null));
        throw new Error(err);
      });
  });
  return loadReviewsPromise;
}

export const ReviewsThunk =
  (inputPayload: LoadReviewsActionPayload): ThunkResult<void> =>
  async (dispatch, getState) => {
    const payload = inputPayload;
    if (getState()) {
      if (!payload.limit) {
        payload.limit = getState().limit;
      }
      if (!payload.product_id) {
        payload.product_id = getState().productId;
      }
      if (!payload.store_id) {
        payload.store_id = getState().storeId;
      }
      if (!payload.page) {
        payload.page = getState().page;
      }
    }
    dispatch(loadReviews(payload));
    const response = await loadReviewsRequest(dispatch, payload);
    dispatch(loadReviewsSuccess(response.data));
  };

export default ReviewsThunk;
